// extracted by mini-css-extract-plugin
export default {"your_rd":"rB","title":"sB","subtitle":"tB","rd_bio_wrapper":"uB","rd_text_mobile":"vB","rd_bio":"wB","img":"xB","rd_info":"yB","rd_name":"zB","rd_stat":"AB","rd_text":"BB","btn_mobile":"CB"};
    if(module.hot) {
      // 1721922364119
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  